import React, { useMemo } from "react";
import { Tooltip } from "@mui/material";
import { BsThreeDotsVertical } from "react-icons/bs";

import APopover from "views/pages/manage/common/a-popover";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import DepositedListAction from "./DepositedListAction";

import CancelChequeForm from "./CancelChequeForm";
import ChequeDateExtensionForm from "./ChequeDateExtensionForm";
import RevokeConfirmation from "./RevokeConfirmation";

import { REACT_ICONS_STYLE } from "views/pages/manage/edpOps/constant/batch-search";
import { handleChequeStatusUpdateWithPreCheck } from "../../utils";

// -------------------- STATUS CONFIG --------------------

const CANCEL_RETURN_STATUS = ["NOT_DEPOSITED", "DATE_EXTENDED"];

const DATE_EXTENDED_STATUS = [
  "NOT_DEPOSITED",
  "DATE_EXTENDED",
  "ACTION_NEEDED",
];

const BOUNCE_ABLE_STATUS = ["DEPOSITED"];

const REVOKE_ABLE_STATUS = [
  "L1_PENDING",
  "L2_PENDING",
  "L3_PENDING",
  "APPROVED",
];

// ------------------------------------------------------

const DepositedActionMenu = ({
  row,
  openModal,
  hideModal,
  refreshList,
  state,
  setState
}) => {
  const menuItems = useMemo(
    () => [
      // ================= CANCEL / RETURN =================
      {
        text: "Cancel/Return",
        isDisabled: (rowData) =>
          !CANCEL_RETURN_STATUS.includes(rowData.status),

        handleClick: async (rowData,setState, state) => {
          debugger
          await handleChequeStatusUpdateWithPreCheck({
            setState,
            rowData,
            actionType: "CANCEL",
            openModal,
            hideModal,
            title: `Cheque Cancellation Alert - ${rowData.referenceNumber}`,
            openFinalModal: (finalState) => {
              openModal({
                title: "Cancel or Return cheque/DD status",
                content: (
                  <CancelChequeForm
                    refreshList={refreshList}
                    mode="CANCEL"
                    row={rowData}
                    state={finalState}
                    setState={setState}
                  />
                ),
                maxWidth: "lg",
              });
            },
          });
        },
      },

      // ================= BOUNCE =================
      {
        text: "Bounce",
        isDisabled: (rowData) =>
          !BOUNCE_ABLE_STATUS.includes(rowData.status),

        handleClick: async (rowData, setState, state) => {
          await handleChequeStatusUpdateWithPreCheck({
            setState,
            rowData,
            actionType: "BOUNCE",
            openModal,
            hideModal,
            title: `Cheque Bounce Alert - ${rowData.referenceNumber}`,
            openFinalModal: (finalState) => {
              openModal({
                title: "Bounce cheque",
                content: (
                  <CancelChequeForm
                    refreshList={refreshList}
                    mode="BOUNCE"
                    row={rowData}
                    state={finalState}
                    setState={setState}
                  />
                ),
                maxWidth: "lg",
              });
            },
          });
        },
      },

      // ================= DATE EXTENSION =================
      {
        text: "Date Extension",
        isDisabled: (rowData) =>
          !DATE_EXTENDED_STATUS.includes(rowData.status),

        handleClick: async (rowData, setState, state) => {
          await handleChequeStatusUpdateWithPreCheck({
            setState,
            rowData,
            actionType: "DATE_EXTENSION",
            openModal,
            hideModal,
            title: `Cheque Date Extension Alert - ${rowData.referenceNumber}`,
            openFinalModal: (finalState) => {
              openModal({
                title: "Cheque date extension",
                content: (
                  <ChequeDateExtensionForm
                    refreshList={refreshList}
                    row={rowData}
                    state={finalState}
                    setState={setState}
                  />
                ),
                maxWidth: "lg",
              });
            },
          });
        },
      },

      // ================= REVOKE =================
      {
        text: "Revoke",
        isDisabled: (rowData) =>
          !REVOKE_ABLE_STATUS.includes(rowData?.approvalStatus),

        handleClick: async (rowData, setState, state) => {
          await handleChequeStatusUpdateWithPreCheck({
            setState,
            rowData,
            actionType: "REVOKE",
            openModal,
            hideModal,
            title: `Cheque Revoke Alert - ${rowData.referenceNumber}`,
            openFinalModal: (finalState) => {
              openModal({
                title: "",
                content: (
                  <RevokeConfirmation
                    refreshList={refreshList}
                    mode="REVOKE"
                    row={rowData}
                    handleClose={hideModal}
                    state={finalState}
                    setState={setState}
                  />
                ),
                maxWidth: "lg",
              });
            },
          });
        },
      },
    ],
    [openModal, hideModal, refreshList, state]
  );

  return (
    <APopover
      buttonComponent={(onClick) => (
        <Tooltip title="More Actions">
          <span onClick={onClick}>
            <IconButtonWrapper>
              <BsThreeDotsVertical style={REACT_ICONS_STYLE} />
            </IconButtonWrapper>
          </span>
        </Tooltip>
      )}
      menuComponent={(closeForm) => (
        <DepositedListAction
          handleClose={closeForm}
          menuItems={menuItems}
          rowData={row}
          setState={setState}
          state={state}
        />
      )}
      sx={{
        "& .MuiPaper-root": {
          border: "1px solid #E2E2E2",
          boxShadow: "0px 3px 4px 0px #00000014 !important",
          borderRadius: "8px",
        },
      }}
    />
  );
};

export default React.memo(DepositedActionMenu);
